<template>
    <div>
      <div
        style="
          width: 100vw;
          height: 100vh;
          background-image: url('/img/webbg.png');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
        "
      >
        <div class="container">
          <div style="display: flex;justify-content: center;align-items: center;height: 20vh;">
              <span>选择页面</span>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content:center;align-items: center;overflow: auto;align-self: center;">
            <!-- <router-link to="/dl" tag="div" class="link-style" >
              <img src="../assets/img/choice/szr_tp01@2x.png" style="width: 87px;height: 90px;">
              <span style="font-weight: bold;">数字人</span>
              <span style="color:#D1D1D1;">H5页面</span>
            </router-link>
            <router-link to="/pc" tag="div" class="link-style">
              <img src="../assets/img/choice/szr_tp01@2x.png" style="width: 87px;height: 90px;">
              <span style="font-weight: bold;">数字人</span>
              <span style="color:#D1D1D1;">web页面</span>
            </router-link> -->

            <router-link to="/code" tag="div" class="link-style" >
              <img src="../assets/img/choice/szr_tp01@2x.png" style="width: 87px;height: 90px;">
              <span style="font-weight: bold;">数字人</span>
              <span style="color:#D1D1D1;">网页二维码输入</span>
            </router-link>

            <!-- <router-link to="/model" tag="div" class="link-style">
              <img src="../assets/img/choice/szr_tp02@2x.png" style="width: 87px;height: 90px;">
              <span style="font-weight: bold;">数字人</span>
              <span style="color:#D1D1D1;">模型选择页面</span>
            </router-link>

            <router-link to="/sheep" tag="div" class="link-style" >
              <img src="../assets/img/choice/szr_tp03@2x.png" style="width: 87px;height: 90px;">
              <span style="font-weight: bold;">数字人</span>
              <span style="color:#D1D1D1;">羊模型页面</span>
            </router-link>

            <router-link to="/changeBk" tag="div" class="link-style">
              <img src="../assets/img/choice/szr_tp01@2x.png" style="width: 87px;height: 90px;">
              <span style="font-weight: bold;">数字人</span>
              <span style="color:#D1D1D1;">网页多背景选择</span>
            </router-link>

            <router-link to="/yx" tag="div" class="link-style">
              <img src="../assets/img/choice/szr_tp01@2x.png" style="width: 87px;height: 90px;">
              <span style="font-weight: bold;">数字人</span>
              <span style="color:#D1D1D1;">云西</span>
            </router-link> -->

          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "Login",
    data() {
      return {
        userName: "",
        password: "",
      };
    },
    mounted(){
      // this.$router.go();
    },
    methods: {
      login() {
          let loginInfo = {
              account: this.userName,
              password:this.password,
              grantType:"username"
          }
          this.$axios.post(this.$urls.loginUrl,loginInfo).then((res)=>{
          console.log("resres",res)
            if(res.code==0){
              localStorage.setItem("USER_INFO",res.data)
              
            }
        })
      },
    },
  };
  </script>
  <style scoped>
  .container {
    position: absolute;
    margin-left: 15vw;
    top: 15vh;
    width: 70vw;
    height: 70vh;
    /* padding: 5vw; */
    background-color:#FBFBFB;
    border: 0.1vh solid #ccc;
    border-radius: 5px;
  }

  .link-style{
           width: 164px;
           height: 157px;
            border-radius: 0px 0px 0px 0px;
            background-color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 2;

  }
  .link-style:hover {
        background-color:#A7A7A7;
        color: white;
    }

/*   
  .container h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 5px;
  }
  
  .form-group input {
    width: 98%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 3px;
  }
  
  .btn {
    width: 100%;
    margin-left: 0.5vw;
    padding: 8px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }


  .custom-link {
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  text-decoration: none;
  border: none;
  border-radius: 5px;
}

.custom-link:hover {
  background-color: #0056b3;
} */
  </style>